import React from "react";

const DescriptionDentalCamp = () => {
  return (
    <div className="dentalcamp-container">
      <div className="dentalcamp-hero">
        
        <h1 className="dentalcamp-title">Want to Organize a
          <span className="pinkhighlig"> Dental Checkup Camp?</span>
        </h1>
      </div>

      <div className="dentalcamp-content">
        <p>Looking to arrange dental checkups at your school, office, factory, or organization?</p>

        <p>
          With <strong>Dr Planete</strong>, it's easy! You can post a request and connect with dentists or hospitals who are part of our platform.
        </p>

        <p><strong>Dental checkups help in:</strong></p>
        
          <li>Spotting cavities early</li>
          <li>Teaching good brushing habits</li>
          <li>Preventing future dental problems</li>
          <li>Promoting better oral health for everyone</li>

          <hr></hr>
        <p><strong>How It Works:</strong></p>
        
          <p>Post your dental checkup request on <strong>Dr Planete</strong>.</p>
          <p>Dentists and hospitals who are Dr Planete members will be notified.</p>
          <p>Interested dentists or hospitals will contact you directly if they’re available.</p>
        
      </div>
    </div>
  );
};

export default DescriptionDentalCamp;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .dentalcamp-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .dentalcamp-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .dentalcamp-subtitle {
    color: white;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .dentalcamp-title {
    font-size: 50px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .dentalcamp-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .dentalcamp-content ul,
  .dentalcamp-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .dentalcamp-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .dentalcamp-title {
      font-size: 36px;
    }

    .dentalcamp-subtitle {
      font-size: 20px;
    }

    .dentalcamp-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
